import { Routes, Route } from 'react-router-dom';
import { CartProvider } from '@contexts/CartContext';
import { AuthProvider } from '@contexts/AuthContext';
import { BookingProvider } from '@contexts/BookingContext';

// Customer Pages
import HomePage from '@pages/customer/HomePage';
import ProductsPage from '@pages/customer/ProductsPage';
import ProductDetailPage from '@pages/customer/ProductDetailPage';
import ServiceBookingPage from '@pages/customer/ServiceBookingPage';
import CartPage from '@pages/customer/CartPage';
import B2BPortalPage from '@pages/customer/B2BPortalPage';
import LoginPage from '@pages/customer/LoginPage';
import ForgotPasswordPage from '@pages/customer/ForgotPasswordPage';

// Admin Pages
import AdminDashboard from '@pages/admin/AdminDashboard';
import AdminProducts from '@pages/admin/AdminProducts';
import AdminOrders from '@pages/admin/AdminOrders';
import AdminBookings from '@pages/admin/AdminBookings';
import AdminB2BAccounts from '@pages/admin/AdminB2BAccounts';
import AdminInventory from '@pages/admin/AdminInventory';

// Layouts
import CustomerLayout from './layouts/CustomerLayout';
import AdminLayout from './layouts/AdminLayout';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BookingProvider>
          <Routes>
            {/* Auth Routes (without layout) */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            
            {/* Customer Routes */}
            <Route path="/" element={<CustomerLayout />}>
              <Route index element={<HomePage />} />
              <Route path="products" element={<ProductsPage />} />
              <Route path="products/:id" element={<ProductDetailPage />} />
              <Route path="services" element={<ServiceBookingPage />} />
              <Route path="cart" element={<CartPage />} />
              <Route path="b2b" element={<B2BPortalPage />} />
            </Route>

            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="b2b-accounts" element={<AdminB2BAccounts />} />
              <Route path="inventory" element={<AdminInventory />} />
            </Route>
          </Routes>
        </BookingProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;

